export default "__VITE_ASSET__BjKH$SCO__"